module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/position-67f140a821125f38fa03d29690c63c52.svg";